export default "__VITE_ASSET__8c3c83ae__"